import React from 'react'

import classes from './Form.scss'
import InputGroup from '../../../../UI/Forms/InputGroup/InputGroup'
import ToggleCheckbox from '../../../../UI/ToggleCheckbox/ToggleCheckbox'

const Form = props => {
  const form = Object.entries(props.form).map(item => {
    let [formKey, formAttrs] = item
    if (formAttrs.elementType === 'toggleCheckbox') {
      
      return (
        <ToggleCheckbox
          key={formKey}
          title={formAttrs.title}
          show={formAttrs.open}
          variant={'inputgroup'}
          changed={() => props.toggleCheckbox(formKey)}>
          <Form
            form={formAttrs.form}
            inputChanged={(Key, e) => props.inputChanged([formKey, ...Key], e)}
          />
        </ToggleCheckbox>
      )
    } else {
      return (
        <InputGroup
          key={formKey}
          label={formAttrs.label}
          inputType={formAttrs.elementType}
          configs={formAttrs.elementConfig}
          invalid={!formAttrs.valid}
          validations={formAttrs.validation}
          touched={formAttrs.touched}
          changed={e => props.inputChanged([formKey], e)}
          inputValue={formAttrs.value}
          validationError={formAttrs.error}
        />
      )
    }
  })

  return <div className={classes.Form}>{form}</div>
}

export default Form
